import { render, staticRenderFns } from "./FleetMonitoring.vue?vue&type=template&id=2ff4cfe3&scoped=true"
import script from "./FleetMonitoring.vue?vue&type=script&lang=js"
export * from "./FleetMonitoring.vue?vue&type=script&lang=js"
import style0 from "./FleetMonitoring.vue?vue&type=style&index=0&id=2ff4cfe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4cfe3",
  null
  
)

export default component.exports